/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSkeleton as ResolvedStandaloneSkeleton } from 'base/components/standalone/Skeleton';

export const Skeleton: typeof ResolvedStandaloneSkeleton = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSkeleton {...props} />
        </ErrorBoundary>
    );
});

export type SkeletonProps = PropsFromComponent<typeof Skeleton>;

/** @deprecated Use slot architecture instead */
export const SkeletonWith = (extras: DynamicStandaloneExtras): typeof Skeleton => {
    return function Skeleton(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Skeleton');
        return <ResolvedStandaloneSkeleton {...mergeProps({ options: { theme } }, props)} />;
    }
}